import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  ["Aloha Corfu Transfers", "/"],
  ["Airport Transfers", "/airport-transfers"],
  ["Port Transfers", "/transfers/port"],
  ["Private Tours in Corfu", "/tours"],
  ["Chauffeur Service", "/chauffeur"],
  ["About Us", "/about"],
  ["Contact", "/contact"],
];

export const RelatedLinks = ({ current }) => (
  <nav aria-label="Related pages" className="max-w-7xl mx-auto px-6 pb-10 sm:pb-14 text-[13.5px] sm:text-[14.5px] text-[#202522]/60" data-testid="related-links">
    <span className="mr-2">Explore:</span>
    {LINKS.filter(([, h]) => h !== current).map(([l, h], i) => (
      <React.Fragment key={h}>
        {i > 0 && <span className="mx-2 text-[#183C35]/25">·</span>}
        <Link to={h} className="text-[#3E7F8E] hover:text-[#183C35] transition-colors duration-200" data-testid={`related-link-${h === "/" ? "home" : h.split("/").pop()}`}>{l}</Link>
      </React.Fragment>
    ))}
  </nav>
);
